import { ReactNode } from "react";

export interface PriceCardProps {
  label?: string;
  price?: number;
  count?: number;
  icon?: ReactNode;
  currency?: string;
}
export function PriceCard(props: PriceCardProps) {
  const { icon, label, price, currency, count } = props;
  return (
    <div
      style={{
        display: "flex",
        alignItems: "flex-end",
        gap: 20,
        padding: 16,
        border: "1px solid #DCDFE8",
        borderRadius: 6,
        // minWidth: 200,
      }}
    >
      <div style={{ display: "flex", flexDirection: "column", justifyContent: "flex-end", gap: 20 }}>
        <span style={{ fontSize: 16, color: "#7A7A7A" }}>{label}</span>
        <div style={{ display: "flex", gap: 10, alignItems: "center" }}>
          <span style={{ fontSize: 20, color: "#515151" }}>
            {price ? Intl.NumberFormat().format(price) : 0}
          </span>
          <span style={{ fontSize: 14, color: "#95A3B5" }}>{currency || "ريال"}</span>
        </div>
      </div>
      <div className="flex flex-col-reverse justify-between h-full">
        {icon}
        {!!count && <span style={{ fontSize: 16, color: "#7A7A7A" }}>({count} عدد)</span>}
      </div>
    </div>
  );
}
